function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { Redirect, Route } from 'react-router-dom';

const ConditionalRoute = ({
  as: Aliased = Route,
  condition,
  component: Component,
  render,
  redirectTo,
  useFromURL,
  children,
  onRedirect,
  ...rest
}) => {
  const [redirectURL, searchURL] = redirectTo.split('?');
  return /*#__PURE__*/React.createElement(Aliased, _extends({}, rest, {
    render: router => {
      if (onRedirect) {
        onRedirect(!condition, router);
      }

      return condition ? /*#__PURE__*/React.createElement(React.Fragment, null, children ? children : Component ? /*#__PURE__*/React.createElement(Component, router) : render ? render(router) : null) : /*#__PURE__*/React.createElement(Redirect, {
        to: {
          pathname: useFromURL ? router.location.state?.from || redirectURL : redirectURL,
          search: searchURL ? `?${searchURL}` : undefined,
          state: {
            from: router.location.pathname
          }
        }
      });
    }
  }));
};

ConditionalRoute.defaultProps = {
  useFromURL: false
};
export default ConditionalRoute;